import React, { useEffect, useRef, useState } from 'react';

import styles from './styles.module.css';

type Tab = {
  label: string;
  content: React.ReactNode;
  disabled: boolean | undefined;
  onClick?: () => void;
};

type TabsProps = {
  tabs: Tab[];
};

const Tabs: React.FC<TabsProps> = ({ tabs }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveTabIndex(index);
  };

  const viewportRef = useRef<HTMLDivElement | null>(null);

  const onWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    const elem = document.getElementById('tab-header');
    const content = document.getElementById('content');

    if (elem?.offsetWidth !== content?.offsetWidth) {
      return;
    }

    if (!viewportRef.current || e.deltaY === 0 || e.deltaX !== 0) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const delta = e.deltaY;
    const currPos = viewportRef.current.scrollLeft;
    const scrollWidth = viewportRef.current.scrollWidth;

    const newPos = Math.max(0, Math.min(scrollWidth, currPos + delta));

    viewportRef.current.scrollLeft = newPos;
  };

  useEffect(() => {
    viewportRef.current?.addEventListener('wheel', (e: WheelEvent) => {
      onWheel(e as unknown as React.WheelEvent<HTMLDivElement>);
    });
  }, [onWheel]);

  return (
    <>
      <div className={styles.tabHeader} id="tab-header" ref={viewportRef}>
        {tabs.map((tab, index) => (
          <button
            title={tab.label}
            key={tab.label}
            className={`${styles.tabButton} ${index === activeTabIndex ? styles.active : ''} ${tab.disabled ? styles.disabled : ''}`}
            onClick={() => {
              handleTabClick(index);
              if (tab.onClick) {
                tab.onClick();
              }
            }}
            disabled={tab.disabled}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div>{tabs[activeTabIndex].content}</div>
    </>
  );
};

export default Tabs;
